
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!happypack/loader?id=1!happypack/loader?id=2!sass-resources-loader?{\"resources\":[\"./app/scss/settings/params.scss\",\"./app/scss/settings/mixins.scss\"]}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-8419ffe0\",\"scoped\":false,\"hasInlineConfig\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./K1_wall.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./K1_wall.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8419ffe0\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./K1_wall.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/components/objects/K1_wall.vue
// module id = 601
// module chunks = 0